import { Service } from "../shared/Service";

export class UsuarioService extends Service{
    
    constructor(){
        super('v1/usuario');
    }
}